import React from 'react';
import { ShieldCheck, TrendingUp, Zap, Clock, PackageSearch, Users } from 'lucide-react';
export const WhyTierOne = () => {
  const benefits = [{
    icon: ShieldCheck,
    title: 'Private-Label Production',
    desc: 'We operate behind the scenes. No Tier One logos on your gear, protecting your brand identity and customer relationships.'
  }, {
    icon: TrendingUp,
    title: 'Wholesale Margins',
    desc: 'Our pricing structure is built to maximize dealer margins, allowing you to scale your business profitably.'
  }, {
    icon: PackageSearch,
    title: 'Combined Quantity Pricing',
    desc: 'Mix and match items across your order to reach higher discount tiers. 100 jerseys + 100 shorts = 200 piece pricing.'
  }, {
    icon: Zap,
    title: 'Speed & Capacity',
    desc: 'Fast turnarounds and reliable fulfillment for large volume orders, with rush production available on select items.'
  }, {
    icon: Clock,
    title: 'USA-Based Support',
    desc: 'Our dedicated support team is available 9am–10pm EST to assist with orders, artwork, and production questions.'
  }, {
    icon: Users,
    title: 'Built for Dealers',
    desc: 'We provide the tools, support, and production capabilities that dealers, brands, and resellers need to succeed.'
  }];
  return <div className="py-20 lg:py-24 bg-white min-h-[calc(100vh-300px)]" data-id="element-1224">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-1225">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1226">
          <span className="text-sm font-bold uppercase tracking-wider text-brandRed" data-id="element-1227">
            About Us
          </span>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mt-3 mb-5 leading-tight" data-id="element-1228">
            Why Tier One Apparel?
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1229">
            We are a factory-direct wholesale custom apparel platform built
            specifically to elevate your brand. We handle the production, so you
            can focus on sales.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1230">
          {benefits.map((benefit, i) => <div key={i} className="bg-gray50 p-8 rounded-xl border border-gray200" data-id="element-1231">
              <div className="w-14 h-14 rounded-lg bg-white border border-gray200 flex items-center justify-center mb-6" data-id="element-1232">
                <benefit.icon className="w-7 h-7 text-brandRed" strokeWidth={1.5} data-id="element-1233" />
              </div>
              <h3 className="text-xl font-bold text-ink mb-3" data-id="element-1234">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1235">{benefit.desc}</p>
            </div>)}
        </div>
      </div>
    </div>;
};